export const searchResultsRouteMap = {
  subscription: id => `/subscriptions/${id}`,
  product: id => `/products/${id}`,
  vendor: id => `/vendors/${id}`,
  publisher: id => `/publishers/${id}`,
  license: id => `/licenses/${id}`,
  subscription_period: id => `/subscriptions/${id}/price`,
  invoice_vendor: id => `/vendors/${id}/orders-invoices`,
  invoice_publisher: id => `/publishers/${id}/orders-invoices`,
  note: (id, providerType) => `/${providerType}/${id}/notes-tasks`,
  publication: id => `/title-lists/${id}`
}
